import { MarkdownRendererForOnboarding } from "@/common/components/Markdown/MarkdownRendererForOnboarding";
import TextLineListSkeleton from "@/common/components/Skeleton/TextLineListSkeleton";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";

interface Props {
  onboardingDefinitionId: string;
  stepDefinitionId: string;
}

export function OnboardingStepContent({ onboardingDefinitionId, stepDefinitionId }: Props) {
  const request = useApiRequest(
    apiClient.onboardingDefinitionsApi
      .apiV1GuidanceOnboardingDefinitionsOnboardingDefinitionIdStepsStepDefinitionIdContentGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      onboardingDefinitionId: onboardingDefinitionId,
      stepDefinitionId: stepDefinitionId,
    },
    {
      deps: [onboardingDefinitionId, stepDefinitionId],
      skip: false,
    },
  );
  const content = request.data;

  if (request.isLoading) {
    return <TextLineListSkeleton itemCount={5} />;
  }
  if (!content?.markdown) {
    return null;
  }

  return <MarkdownRendererForOnboarding markdown={content.markdown} />;
}
